module.exports = __webpack_public_path__ + "img/product_category_banner-2.1103020.jpg";